import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { IArea, AreaTypes } from '../../../../../../models/types';
import { paths } from '../../../../../Root/paths';
import { iRootState } from '../../../../../../store';

import Tooltip from '../../../../../../components_/Tooltip';
import DrawerContentItemArea from '../../../../../../components_/Drawer/DrawerContentItemArea';
import { EditOutlined, FileTextOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface IProps {
  setBoxEditMode: () => void;
  setCircleEditMode: () => void;
  setPolygonEditMode: () => void;
  isLoading: boolean;
  editAccess: boolean;
  area: IArea | null;
}

const Card: FC<IProps> = ({
  isLoading,
  area,
  setBoxEditMode,
  setCircleEditMode,
  setPolygonEditMode,
  editAccess
}) => {
  const { id, geomType } = area || {};

  const history = useHistory();
  const mapId = useSelector((state: iRootState) => state.infrastructureMap.map.id);

  const handleReportClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!id) return;
    const url = `${paths.reports.stayInAreas}?mapId=${mapId}&listOfAreas=${id}`;
    history.push(url);
  };

  const handleEditClick = () => {
    history.push(paths.map.office.areas.edit(id));

    switch (geomType) {
      case AreaTypes.Box:
        setBoxEditMode();
        break;
      case AreaTypes.Circle:
        setCircleEditMode();
        break;
      case AreaTypes.Polygon:
        setPolygonEditMode();
        break;
    }
  };

  return (
    <DrawerContentItemArea
      isLoading={isLoading}
      area={area}
      variant="card"
      action={
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {editAccess && (
            <Tooltip size="s" label="Редактировать">
              <Button type={'text'} icon={<EditOutlined />} onClick={handleEditClick} />
            </Tooltip>
          )}
          <Tooltip size="s" label="Отчёт по пребыванию">
            <Button
              type={'text'}
              icon={<FileTextOutlined />}
              onClick={handleReportClick}
              disabled={!id}
            />
          </Tooltip>
        </div>
      }
    />
  );
};

export default Card;
